<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import {
  getDepartmentAllList,
} from 'api';
import { timeForMat } from '@qx/utils';
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        orgIdOptions: [],
        form: [
          {
            label: '所属部门',
            value: 'orgId',
            type: 'select',
            default: -1,
            placeholder: '请选择所属部门',
          },
          {
            label: '开始日期',
            value: 'startTime',
            type: 'date',
            default: timeForMat(60),
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '结束日期',
            value: 'endTime',
            type: 'date',
            default: this.formatDate(new Date()),
            attr: {
              time: '00:00:00',
            },
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      searchBoxData.startTime = this.formatDate(searchBoxData.startTime);
      searchBoxData.endTime = this.formatDate(searchBoxData.endTime);
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    this.searchBoxData.orgIdOptions = [
      { label: '全部', value: -1 },
      ...((await getDepartmentAllList()) || []),
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
